"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalRoutes = void 0;
// This is a const and not enum due to some routes requiring computed values
exports.ExternalRoutes = {
    CampaignAppVaccine: '/campaign/vaccination/proof',
    News: '/feed?category=news',
    TimeAppVto: '/time/optional',
    VtoApp: '/voluntary_time_off',
    SwapApp: '/swaps',
    RequestTimeOff: '/time/request',
    Notifications: "/feed",
    ShoutOuts: '/shout-outs',
    LearnHubApp: '/learn/home',
    MyVoice: '/myvoice'
};
